import {useQuery} from "react-query"
import {ImageResourceApi} from "api/image-resource.api"

export const useImageResource = (id: string) => {
    return useQuery(["file-resource/image", id], async () => {
        const result = await ImageResourceApi.findImageResourceById(id)
        return result?.data
    }, {
        refetchIntervalInBackground: false,
        // refetchInterval: 3000,
    })
}
